module.exports = __webpack_public_path__ + "static/img/news_activity.caf2353.png";


//////////////////
// WEBPACK FOOTER
// ./public/newsImg/news_activity.png
// module id = LoqN
// module chunks = 0